type SearchNavigationDirection = -1 | 1 | null

function preferredSearchScrollBehavior(): ScrollBehavior {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    ? 'auto'
    : 'smooth'
}

export function scrollSearchOverviewIntoView(
  overviewAnchor: HTMLElement,
  controls: HTMLElement,
): void {
  const controlsHeight = controls.getBoundingClientRect().height
  const stickyTop = Number.parseFloat(getComputedStyle(controls).top) || 0
  overviewAnchor.style.scrollMarginTop = `${Math.max(0, controlsHeight + stickyTop)}px`
  overviewAnchor.scrollIntoView({ block: 'start', behavior: preferredSearchScrollBehavior() })
}

export function scrollSearchResultIntoView(
  result: HTMLElement,
  controls: HTMLElement,
  overviewAnchor: HTMLElement,
  navigationDirection: SearchNavigationDirection = null,
): void {
  const scrollBehavior = preferredSearchScrollBehavior()
  const listbox = result.closest<HTMLElement>('[role="listbox"]')
  const resultTop = result.getBoundingClientRect().top
  const firstVisualRowTop = listbox
    ?.querySelector<HTMLElement>('.search-result')
    ?.getBoundingClientRect().top ?? Number.POSITIVE_INFINITY
  const isInFirstVisualRow = Math.abs(resultTop - firstVisualRowTop) <= 1

  if (navigationDirection === -1 && isInFirstVisualRow) {
    scrollSearchOverviewIntoView(overviewAnchor, controls)
    return
  }

  const controlsRect = controls.getBoundingClientRect()
  const stickyTop = Number.parseFloat(getComputedStyle(controls).top) || 0
  const controlsArePinned = controlsRect.top <= stickyTop + 1
  const searchBoxBottom = controls.querySelector<HTMLElement>('.search-box')
    ?.getBoundingClientRect().bottom ?? controlsRect.bottom
  const unobstructedTop = controlsArePinned
    ? Math.max(0, controlsRect.bottom, searchBoxBottom)
    : 0
  result.style.scrollMarginTop = `${unobstructedTop}px`
  result.scrollIntoView({ block: 'nearest', behavior: scrollBehavior })
}

export function scrollSearchNavigationIntoView(
  result: HTMLElement | null,
  controls: HTMLElement,
  overviewAnchor: HTMLElement,
  navigationDirection: SearchNavigationDirection,
): void {
  if (!result) {
    if (navigationDirection === -1) {
      scrollSearchOverviewIntoView(overviewAnchor, controls)
    }
    return
  }

  scrollSearchResultIntoView(result, controls, overviewAnchor, navigationDirection)
}
